<div [class.rtl]="currLang == 'ar'" class="modal" id="add-flow-popup" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" *ngIf="editFlag">{{'dismissal-flow.add-flow.edit' | translate}}</h5>
                <h5 class="modal-title" *ngIf="!editFlag">{{'dismissal-flow.add-flow.add' | translate}}</h5>
                <div class="header-btns">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-body" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                <h5>{{'dismissal-flow.add-flow.flow-info' | translate}}</h5>
                <div class="row">
                    <div class="col-6">
                        <!-- {{grades.length}} -->
                        <!-- <mat-form-field appearance="outline" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}" dir="ltr">
                            <mat-label>{{'dismissal-flow.add-flow.grades' | translate}}</mat-label>
                            <mat-select [(ngModel)]="selectedGrades" multiple
                                (selectionChange)="gradeSelectted($event)">
                                <mat-option [value]="grade.id" *ngFor="let grade of grades">
                                    {{grade.name}}</mat-option>
                            </mat-select>
                        </mat-form-field> -->
                        <p-multiSelect #multiSelectFlow [options]="allGrades"
                        [(ngModel)]="selectedGrades" (onChange)="gradeSelectted($event)"
                        defaultLabel="{{'dismissal-flow.add-flow.grades' | translate}}"
                        emptyMessage="{{'dismissal-flow.add-flow.no-grades' | translate}}"
                        emptyFilterMessage="{{'dismissal-flow.add-flow.no-grades-filter' | translate}}"></p-multiSelect>
                    </div>
                </div>
                <br>
                <h5>{{'dismissal-flow.add-flow.select-flow' | translate}}</h5>
                <small>{{'dismissal-flow.add-flow.select-hints' | translate}}</small><br>
                <small>{{'dismissal-flow.add-flow.select-hints2' | translate}}</small>
                <div class="row">
                    <div class="col-lg-1"></div>
                    <div class="route col-lg-10">
                        <div class="first">
                            <div class="stage" [ngClass]="flowStagesFlags[0] ? 'active' : 'inactive'" triggers="manual"
                                #t1="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate1"></div>
                            <div class="name" [ngClass]="flowStagesFlags[0] ? 'active' : 'inactive'">
                                {{'dismissal-flow.request' | translate}}</div>
                        </div>
                        <ng-template #infoTemplate1>
                            <div class="info-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span class="header">{{'dismissal-flow.request' | translate}}</span><br><br>
                                <!-- <div>Confirming of receive the student to end the dismissal process</div> -->
                            </div>
                        </ng-template>
                        <div (click)="changeStageState(1)">
                            <div class="stage" [ngClass]="flowStagesFlags[1] ? 'active' : 'inactive'" triggers="manual"
                                #t2="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate2" (mouseover)="t2.open()" (mouseout)="t2.close()"></div>
                            <div class="name" [ngClass]="flowStagesFlags[1] ? 'active' : 'inactive'">
                                {{'dismissal-flow.teacher' | translate}}</div>
                        </div>
                        <ng-template #infoTemplate2>
                            <div class="info-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span class="header">{{'dismissal-flow.teacher' | translate}}</span><br><br>
                                <div>{{'dismissal-flow.add-flow.teacher-hint' | translate}}</div>
                            </div>
                        </ng-template>
                        <div (click)="changeStageState(2)">
                            <div class="stage" [ngClass]="flowStagesFlags[2] ? 'active' : 'inactive'" triggers="manual"
                                #t3="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate3" (mouseover)="t3.open()" (mouseout)="t3.close()"></div>
                            <div class="name" [ngClass]="flowStagesFlags[2] ? 'active' : 'inactive'">
                                {{'dismissal-flow.supervisor' | translate}}</div>
                        </div>
                        <ng-template #infoTemplate3>
                            <div class="info-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span class="header">{{'dismissal-flow.supervisor' | translate}}</span><br><br>
                                <div>{{'dismissal-flow.add-flow.supervisor-hint' | translate}}</div>
                            </div>
                        </ng-template>
                        <div (click)="changeStageState(3)">
                            <div class="stage" [ngClass]="flowStagesFlags[3] ? 'active' : 'inactive'" triggers="manual"
                                #t4="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate4" (mouseover)="t4.open()" (mouseout)="t4.close()"></div>
                            <div class="name" [ngClass]="flowStagesFlags[3] ? 'active' : 'inactive'">
                                {{'dismissal-flow.guard' | translate}}</div>
                        </div>
                        <ng-template #infoTemplate4>
                            <div class="info-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span class="header">{{'dismissal-flow.guard' | translate}}</span><br><br>
                                <div>{{'dismissal-flow.add-flow.guard-hint' | translate}}</div>
                            </div>
                        </ng-template>
                        <div class="last" (click)="changeStageState(4)">
                            <div class="stage" [ngClass]="flowStagesFlags[4] ? 'active' : 'inactive'" triggers="manual"
                                #t5="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate5" (mouseover)="t5.open()" (mouseout)="t5.close()"></div>
                            <div class="name" [ngClass]="flowStagesFlags[4] ? 'active' : 'inactive'">
                                {{'dismissal-flow.parent' | translate}}</div>
                        </div>
                        <ng-template #infoTemplate5>
                            <div class="info-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span class="header">{{'dismissal-flow.parent' | translate}}</span><br><br>
                                <div>{{'dismissal-flow.add-flow.parent-hint' | translate}}</div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="col-lg-1"></div>
                </div>
            </div>
            <div class="modal-footer">
                <button [disabled]="selectedGrades.length == 0" class="btn btn-primary next" type="button"
                    (click)="saveFlow()" [disabled]="!saveBtnFlag">{{'dismissal-flow.add-flow.save' |
                    translate}}</button>
            </div>
        </div>
    </div>
</div>